// extracted by mini-css-extract-plugin
module.exports = {"web":"GameTime_web__2JFr5"};